/* eslint-disable @typescript-eslint/naming-convention */

// controlled by a gradual rollout flag
// https://unleash-ab-testing-production.lmndprod.com/projects/default/features/uniclient_mixpanel_session_replay
export function initSessionReplay() {
  window.analytics?.ready?.(() => {
    if (window.mixpanel == null) {
      return;
    }

    const sessionReplayUrl = window.mixpanel.get_session_recording_url();

    if (sessionReplayUrl == null) {
      return;
    }

    window.mixpanel.start_session_recording();
  });
}
